import Vue from 'vue';
import apis from '../apis';
import { set } from 'nprogress';

// initial state
const state = {
    order_statuses: ['未开始', '进行中', '已交付', '已完成', '已推迟', '已终止', '已退单'],
    order_file_types: ['招标文件', '资料清单', '初稿文件', '终稿文件', '转账凭证', '发票票据', '客户沟通', '合同协议', '技术方案', '中标证明'],
    salor_log_types: ['有效', '待跟', '无效', '老客户'],
    payment_refund_types: ['服务项变更', '废标', '项目终止', '已从其他账户转账', '金额订正', '录入错误', '客户多付'],
    order_file_tags: [{
        name: '工程类',
        children: ['EPC项目','安防工程','安装工程','车库工程','道路工程','地铁工程',
        '电力工程','风电工程','改造工程','钢结构工程','公路工程','环境治理','基础工程',
        '架空线工程','监理工程','建筑工程','交通工程','空调工程','冷库建设','绿化工程',
        '门窗工程','幕墙工程','暖通工程','桥梁工程','人防工程','市政工程','水电工程',
        '隧道隧洞','铁塔基站','通信工程','土建工程','维修工程','油烟管道清洗','装饰装修','其他工程']
    }, {
        name: '采购类',
        children: ['办公采购','材料采购','电器采购','服装采购','副食品采购','供货采购',
        '机械采购','家具采购','建材采购','建筑采购','配件采购','汽车采购','器械采购','设备采购',
        '食材采购','食品采购','图书采购','医疗采购','政府采购','其他采购']
    }, {
        name: '服务类',
        children: ['保安服务','保洁服务','餐饮服务','管理服务','环卫服务','会务服务','看护服务',
                    '旅游服务','设计服务','体验服务','外包服务','维修服务','物流服务','物业服务',
                    '销售服务','宣传服务','养护服务','养老服务','幼儿园','运营服务','支撑服务',
                    '咨询服务','租赁服务','其他服务']
    }],
    baseCities: ['北京', '许昌'],
    employeeBaseCities: [],
    employeeDuties: [],
    branchCompanyNames: [],
    areaBranchCompanyNames: [],
}


// getters
const getters = {
    
}

// actions
const actions = {
    refresh(context) {
        Vue.prototype.$http.get(apis.API_OPS_DICTS, {
            params: {
                dict_type: 'branchCompany'
            }
        }).then(response => {
            if (response.data.success) {
                context.commit('setBranchCompanyNames', response.data.result.list.map(item => item.dict_value));

                const areaNames = response.data.result.list.filter(item => !!item.comment_desc)
                            .map(item => item.comment_desc)
                            .filter((v, i, a) => a.indexOf(v) === i);
                
                context.commit('setAreaBranchCompanyNames', areaNames.map(v => {
                    return {
                        name: v,
                        children: response.data.result.list.filter(item => item.comment_desc === v)
                                        .map(item => item.dict_value)
                    }
                }))
            }
        });

        Vue.prototype.$http.get(apis.API_OPS_DICTS, {
            params: {
                dict_type: 'employeeBaseCity'
            }
        }).then(response => {
            if (response.data.success) {
                context.commit('setEmployeeBaseCities', response.data.result.list.map(item => item.dict_value));
            }
        });

        Vue.prototype.$http.get(apis.API_OPS_DICTS, {
            params: {
                dict_type: 'employeeDuty'
            }
        }).then(response => {
            if (response.data.success) {
                context.commit('setEmployeeDuties', response.data.result.list.map(item => item.dict_value));
            }
        });
    }
}

// mutations
const mutations = {
    setEmployeeBaseCities(state, payload) {
        state.employeeBaseCities = payload;
    },
    setBranchCompanyNames(state, payload) {
        state.branchCompanyNames = payload;
    },
    setAreaBranchCompanyNames(state, payload) {
        state.areaBranchCompanyNames = payload;
    },
    setEmployeeDuties(state, payload) {
        state.employeeDuties = payload;
    },
}
  
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/dicts.js